<div cdkTrapFocus>
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@disabledServiceTitle">Service Unavailable</h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      ngbAutoFocus
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p i18n="@@ThisServiceIsNotAvailable">
      This service is not available in your company configuration.
    </p>
    <p i18n="@@ToGetThisSwitchedOnPlease">
      To get this switched on, please speak with your Management Team or Account Manager.
    </p>
    <p i18n="@@ThankYou">Thank you.</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      appButton="small"
      aria-label="Close"
      i18n-aria-label
      i18n="@@modalFlightFareOK"
      (keydown.enter)="activeModal.close()"
      (keydown.space)="activeModal.close()"
      (click)="activeModal.close()"
    >
      Close
    </button>
  </div>
</div>
